import { IUpdateItensChecklistUseCase } from "../../../presentation/useCases/update/update_itens_checklist_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * UpdateItensChecklistUseCase
 */

export class UpdateItensChecklistUseCase implements IUpdateItensChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async updateItensChecklist(idItemChecklist: number, idChecklist: number, codigo: string, descricao: string): Promise<void> {
    await this.repository.updateItensChecklist(idItemChecklist, idChecklist, codigo, descricao);
  }
}
